import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { GdlService } from 'src/app/shared/services/gdl-service/gdl.service';
import { SharedService } from 'src/app/shared/services/shared-service/shared.service';

@Component({
  selector: 'wpro-continue-confirmation',
  templateUrl: './continue-confirmation.component.html',
  standalone: false
})

export class ContinueConfirmationComponent implements OnInit {
  gdlModal = 'modal';
  gdlFormName = 'pending-edit-confirmation';

  @Output() hidePopup = new EventEmitter<boolean>();
  @Output() continue = new EventEmitter();


  constructor(public sharedService: SharedService, public gdlService: GdlService) { }

  ngOnInit(): void {
    window.scroll(0, 0);
  }

  closePopup(): void {
    this.hidePopup.emit(false);
    this.gdlService.triggerGdlLogEvent(this.gdlModal, 'dismiss', { name: this.gdlFormName });
  }

  continueClicked(): void {
    this.sharedService.isEditScreen = false;
    this.continue.emit();
    this.gdlService.triggerGdlLogEvent(this.gdlModal, 'confirm', { name: this.gdlFormName, choice: 'confirm' });
  }
}
